import { useApiTradeV1TradeCompaniesRetrieve } from 'api';
import { useTranslation } from 'i18n';
import { Link, useParams } from 'react-router-dom';
import { Button, Page, Section } from 'ui';

import { CompanySites } from '../../components/CompanySites/CompanySites';

export const CompanySiteMaterials = () => {
  const { t } = useTranslation('orders');
  const { companyId } = useParams();
  const { data: tradeCompany } = useApiTradeV1TradeCompaniesRetrieve(Number(companyId));

  return (
    <Page>
      <Page.BackButton
        component="a"
        href={`/ground-control/manage_company/${tradeCompany?.company_id}/`}
        disabled={!tradeCompany}
      >
        {t('siteMaterials.listPage.actions.manageCompany', { values: { companyName: tradeCompany?.name } })}
      </Page.BackButton>

      <Page.Title title={t('siteMaterials.listPage.title')} />
      <Page.Divider />

      <Section
        title={t('siteMaterials.listPage.sectionTitle')}
        action={
          tradeCompany ? (
            <Button component={Link} to={`/ground-control/v2/manage-company/${tradeCompany.id}/site-materials/new`}>
              {t('siteMaterials.listPage.actions.addSiteMaterial')}
            </Button>
          ) : null
        }
      >
        <CompanySites tradeCompanyId={Number(companyId)} />
      </Section>
    </Page>
  );
};
